import { useRef, useState } from 'react';

import { useOpenTrigger } from 'hooks/useOpenTrigger';
import { MenuContent } from './content';

import { Icon } from 'common/icon';
import { useClickOutside } from 'hooks/useClickOutside';

import styles from './styles.module.css';

export const Menu = ({
  onOpenChange,
}: {
  onOpenChange?: (isOpen: boolean) => void;
}) => {
  const menuRef = useRef(null);

  const [isOpen, setOpen] = useState(false);
  const state = useOpenTrigger({ isOpen, setOpen });

  const handleClose = () => {
    setOpen(false);
    if (onOpenChange) {
      onOpenChange(false);
    }
  };

  useClickOutside({ onClick: handleClose, ref: menuRef });

  const handleToggle = () => {
    state.toggle();
    const newValue = !isOpen;
    if (onOpenChange) {
      onOpenChange(newValue);
    }
  };

  const renderIcon = isOpen ? (
    <Icon.Close width={26} height={26} />
  ) : (
    <Icon.Menu />
  );

  return (
    <div ref={menuRef} className={styles.wrapper_menu}>
      <div className={styles.menu__btn} onClick={handleToggle}>
        {renderIcon}
      </div>
      <MenuContent state={state} />
    </div>
  );
};
